export default __webpack_public_path__ + "static/media/step_2_dont_2.543adc19.jpg";